// modules/gerente/components/GerenciaLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import GerenciaNavbar from '../components/NavbarG';
import ErrorBoundary from '../../../components/ErrorBoundary';

const GerenciaLayout = () => {
    return (
        <ErrorBoundary>
            <div className="gerencia-layout">
                <GerenciaNavbar />
                <div className="gerencia-content">
                    <Outlet />
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default GerenciaLayout;
